/* ============================================================================
   presence.js — statusul online (v9 8.14)
   ----------------------------------------------------------------------------
   RO: Un punct verde discret + „Online", ca în WhatsApp, în DM (antet), în
       profilul public și pe avatarele din chatul de club; setarea „Cine vede când
       sunt online" (Toți / Nimeni) e în profil.
       Deciziile lui Alex (D19): Toți / Nimeni, implicit Toți; RECIPROCITATE (cu
       „Nimeni" nu apari online și nici nu-i vezi pe alții); fără „văzut ultima
       dată" (nimic salvat pe server); canal PERSONAL pentru fiecare utilizator.
       • Canalul personal `user-presence:<id>`: apari pe el cât folosești aplicația
         (o conectare realtime la pornire, nicio cerere HTTP). Cei care au o
         legătură reală cu tine (club activ comun, prieten, conversație privată) îl
         pot PRIVI, fără să apară pe el. Totul impus pe server
         (V9_814_PREZENTA_SETARE.sql): „Nimeni", reciprocitatea, blocarea în
         ambele direcții, numele de canal valid.
       • DM și profil: canalul personal al celuilalt e urmărit doar cât e deschisă
         conversația / profilul (marcat cu `data-pres-watch`), apoi părăsit.
       • Club: punctele din chat folosesc canalul clubului (P2b), deja deschis.
       • Setarea e în `profile_extra.presence` (ca dmPolicy): doar 'none' ascunde;
         după salvare, canalele se redeschid ca serverul să reverifice dreptul.
       • Demo: puncte simulate, zero trafic.
       • Nimic în localStorage; la ieșirea din cont se închid toate canalele.
   EN: online status — own private channel per user (server-enforced setting,
       reciprocity and blocks), watched only while a DM / profile is open; club
       dots reuse the club presence channel. One `window.TO_PRES`.
   ============================================================================ */
(function () {
    'use strict';
    if (window.TO_PRES) return;
    var TO_PRES = {};
    window.TO_PRES = TO_PRES;

    var own = { ch: null, uid: null };
    var watched = {};                       /* id → { ch, n, online, timer } */
    var pref = null;                        /* 'all' | 'none' după o salvare; null ⇒ din profil */
    var logged = {};
    var UNWATCH_MS = 3000;                  /* DM redeschis imediat (alt DM) ⇒ fără ieșire + intrare */
    var DEMO_ON = { 'Alice': 1, 'Bob': 1, 'demo-alice': 1, 'demo-bob': 1 };   /* demo: puncte simulate (nume și id-uri din datele demo) */

    function logErr(where, e) {
        try { if (typeof window.logError === 'function') window.logError(where, e); } catch (e2) { /* noop */ }
    }
    function logOnce(where, msg) {
        if (logged[where]) return;
        logged[where] = true;
        logErr(where, new Error(msg));
    }
    function st() { return (typeof state !== 'undefined' && state) ? state : null; }
    function myId() { var s = st(); return (s && s.currentUser && s.currentUser.id) || null; }
    function isDemo() { return typeof isDemoMode === 'function' && !!isDemoMode(); }
    function client() { return (typeof sb !== 'undefined' && sb && typeof sb.channel === 'function') ? sb : null; }
    function blocked(id) { return !!(id && typeof window.isBlockedPair === 'function' && window.isBlockedPair(id)); }

    /* Setarea mea. Lista albă, ca pe server: doar 'none' ascunde. */
    function shares() {
        if (pref) return pref !== 'none';
        var s = st(), e = s && s.currentUser && s.currentUser.profileExtra;
        return !(e && typeof e === 'object' && e.presence === 'none');
    }

    /* ── Canalul meu ─────────────────────────────────────────────────────── */
    function ownStop() {
        var c = client();
        if (own.ch && c) { try { c.removeChannel(own.ch); } catch (e) { logErr('TO_PRES.own', e); } }
        own.ch = null; own.uid = null;
    }
    function ownStart() {
        try {
            var uid = myId(), c = client();
            if (isDemo() || !uid || !c || !shares()) { ownStop(); return; }
            if (own.ch && own.uid === uid) return;
            ownStop();
            var ch = c.channel('user-presence:' + uid, { config: { private: true, presence: { key: uid } } });
            own.ch = ch; own.uid = uid;
            ch.subscribe(function (status) {
                if (status === 'SUBSCRIBED') {
                    /* Conținut minim: doar momentul (cine e, spune numele canalului). */
                    Promise.resolve(ch.track({ at: Date.now() })).catch(function (e) { logErr('TO_PRES.track', e); });
                } else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
                    logOnce('TO_PRES.own', 'own presence ' + status);
                }
            });
        } catch (e) { logErr('TO_PRES.own', e); }
    }

    /* ── Canalele altora (DM / profil deschis) ──────────────────────────────── */
    function joinWatch(id, w) {
        var c = client();
        if (w.ch || !c || isDemo() || !shares() || blocked(id) || !myId()) return;
        var ch = c.channel('user-presence:' + id, { config: { private: true, presence: { key: myId() } } });
        w.ch = ch;
        ch.on('presence', { event: 'sync' }, function () {
            try {
                var ps = ch.presenceState() || {};
                w.online = Object.keys(ps).some(function (k) { return (ps[k] || []).length > 0; });
                paint();
            } catch (e) { logErr('TO_PRES.watch', e); }
        });
        ch.subscribe(function (status) {
            if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
                /* Refuzat de server (fără legătură, blocare, „Nimeni"): doar nu apare punctul. */
                w.online = false;
                paint();
            }
        });
    }
    function leaveWatch(w) {
        var c = client();
        if (w.ch && c) { try { c.removeChannel(w.ch); } catch (e) { logErr('TO_PRES.watch', e); } }
        w.ch = null; w.online = false;
    }
    function watch(id) {
        id = String(id || '');
        if (!id || id === myId()) return;
        var w = watched[id] || (watched[id] = { ch: null, n: 0, online: false, timer: 0 });
        w.n++;
        clearTimeout(w.timer); w.timer = 0;
        try { joinWatch(id, w); } catch (e) { logErr('TO_PRES.watch', e); }
    }
    function unwatch(id) {
        id = String(id || '');
        var w = watched[id];
        if (!w) return;
        w.n = Math.max(0, w.n - 1);
        if (w.n) return;
        clearTimeout(w.timer);
        w.timer = setTimeout(function () {
            if (w.n) return;
            leaveWatch(w);
            delete watched[id];
        }, UNWATCH_MS);
    }
    function leaveAll() {
        Object.keys(watched).forEach(function (id) { clearTimeout(watched[id].timer); leaveWatch(watched[id]); });
        watched = {};
    }

    /* ── Afișarea ─────────────────────────────────────────────────────────── */
    /* Online? Reciprocitate și în interfață: cu „Nimeni" nu vezi pe nimeni. Între doi
       care s-au blocat: nimic (pe canalul personal o impune serverul; pe canalul comun al
       clubului doar interfața o poate face). */
    function isOnline(id, name) {
        if (offline()) return false;
        if (isDemo()) return !!((name && DEMO_ON[name]) || (id && DEMO_ON[id]));
        if (!shares() || blocked(id)) return false;
        if (id && watched[id] && watched[id].online) return true;
        if (typeof window.isUserOnline !== 'function') return false;
        return !!((id && window.isUserOnline(id)) || (name && window.isUserOnline(name)));
    }
    /* Punctele (`.presence-dot[data-pres-id]`) și textele „Online" (`[data-pres-status]`),
       actualizate pe loc, fără redesenare (ca `refreshPresenceDots`, KB §45.6). */
    function paint(root) {
        try {
            var r = root || document;
            var dots = r.querySelectorAll('.presence-dot[data-pres-id]');
            for (var i = 0; i < dots.length; i++) {
                var on = isOnline(dots[i].getAttribute('data-pres-id'), dots[i].getAttribute('data-pres-name'));
                if (dots[i].classList.contains('on') !== on) dots[i].classList.toggle('on', on);
            }
            var txt = r.querySelectorAll('[data-pres-status]');
            for (var j = 0; j < txt.length; j++) {
                var on2 = isOnline(txt[j].getAttribute('data-pres-status'), txt[j].getAttribute('data-pres-name'));
                if (txt[j].hidden === on2) txt[j].hidden = !on2;
            }
        } catch (e) { logErr('TO_PRES.paint', e); }
    }
    /* Un punct pe un avatar existent (chatul de club). Construit cu DOM, fără HTML din date. */
    function dot(host, id, name) {
        if (!host) return null;
        var d = host.querySelector(':scope > .presence-dot[data-pres-id]');
        if (!d) {
            d = document.createElement('span');
            d.className = 'presence-dot';
            d.setAttribute('aria-hidden', 'true');
            host.appendChild(d);
        }
        if (d.getAttribute('data-pres-id') !== String(id || '')) d.setAttribute('data-pres-id', String(id || ''));
        if (name && d.getAttribute('data-pres-name') !== String(name)) d.setAttribute('data-pres-name', String(name));
        return d;
    }

    /* DM-ul și profilul public se deschid ca ferestre noi în <body>, marcate cu
       `data-pres-watch="<id>"`: urmărim canalul celuilalt cât sunt pe ecran. */
    function scan(node, fn) {
        if (!node || node.nodeType !== 1) return;
        if (node.hasAttribute('data-pres-watch')) fn(node.getAttribute('data-pres-watch'));
        var l = node.querySelectorAll('[data-pres-watch]');
        for (var i = 0; i < l.length; i++) fn(l[i].getAttribute('data-pres-watch'));
    }
    function bindBody() {
        if (!document.body || document.body.__toPres || typeof MutationObserver !== 'function') return;
        document.body.__toPres = true;
        try {
            new MutationObserver(function (recs) {
                var any = false;
                recs.forEach(function (rec) {
                    for (var i = 0; i < rec.removedNodes.length; i++) scan(rec.removedNodes[i], function (id) { any = true; unwatch(id); });
                    for (var j = 0; j < rec.addedNodes.length; j++) scan(rec.addedNodes[j], function (id) { any = true; watch(id); });
                });
                if (any) paint();
            }).observe(document.body, { childList: true });
        } catch (e) { logErr('TO_PRES.bind', e); }
    }

    /* După salvarea profilului (supabase-integration.js, `updateMyProfile`): setarea
       nouă + intrare din nou pe canale (serverul verifică dreptul la intrare). */
    function refresh(extra) {
        try {
            if (extra && typeof extra === 'object') pref = (extra.presence === 'none') ? 'none' : 'all';
            ownStop();
            leaveAll();
            if (typeof window.subscribeRealtimePresence === 'function') window.subscribeRealtimePresence();
            else ownStart();
            /* conversația / profilul deschis acum: urmărit din nou (doar dacă arăt statusul) */
            scan(document.body, function (id) { watch(id); });
            paint();
        } catch (e) { logErr('TO_PRES.refresh', e); }
    }
    /* 8.14-b: o blocare (sau deblocare) schimbată acum: canalul celui blocat se părăsește
       pe loc, la deblocare se reia dacă DM-ul / profilul lui e încă deschis (block.js,
       `blockRefreshUi`). Serverul refuză oricum la următoarea intrare. */
    function blocksChanged() {
        try {
            Object.keys(watched).forEach(function (id) {
                var w = watched[id];
                if (blocked(id)) leaveWatch(w);
                else if (w.n > 0 && !w.ch) joinWatch(id, w);
            });
            paint();
        } catch (e) { logErr('TO_PRES.blocks', e); }
    }
    function stopAll() {
        ownStop();
        leaveAll();
        pref = null;
        logged = {};
    }

    /* ── Fără internet (29 oct. 2026) ──────────────────────────────────────────
       RO: Defect văzut de Alex: telefonul în mod avion, iar ceilalți rămâneau „Online".
           Starea vine din ultima sincronizare a canalelor; fără rețea, conexiunea moare
           fără să mai anunțe pe nimeni ⇒ lista veche rămânea pe ecran. Acum: fără rețea
           nu știm cine e online ⇒ nimeni (`isOnline`), iar la pierderea conexiunii lista
           clubului și canalele urmărite se golesc PE LOC. La revenire intrăm din nou pe
           canale (ca după salvarea setării): serverul trimite starea proaspătă.
           Cazul „Wi-Fi fără internet" (fără evenimentul `offline`) îl prinde canalul
           clubului, la căderea conexiunii (supabase-integration.js).
       EN: offline ⇒ nobody shown online; on reconnect the channels are rejoined. */
    function offline() { return typeof navigator !== 'undefined' && navigator.onLine === false; }
    function wentOffline() {
        try {
            Object.keys(watched).forEach(function (id) { watched[id].online = false; });
            if (typeof window.renderOnlinePresence === 'function') window.renderOnlinePresence([]);   /* + paint() */
            else paint();
        } catch (e) { logErr('TO_PRES.offline', e); }
    }
    function backOnline() {
        if (!myId() || isDemo()) { paint(); return; }
        refresh();
    }
    try {
        window.addEventListener('offline', wentOffline);
        window.addEventListener('online', backOnline);
    } catch (e) { logErr('TO_PRES.net', e); }

    try {
        if (typeof sb !== 'undefined' && sb && sb.auth && typeof sb.auth.onAuthStateChange === 'function') {
            sb.auth.onAuthStateChange(function (ev) { if (ev === 'SIGNED_OUT') stopAll(); });
        }
    } catch (e) { logErr('TO_PRES.auth', e); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBody);
    else bindBody();

    TO_PRES.shares = shares;
    TO_PRES.ownStart = ownStart;
    TO_PRES.isOnline = isOnline;
    TO_PRES.paint = paint;
    TO_PRES.dot = dot;
    TO_PRES.watch = watch;
    TO_PRES.unwatch = unwatch;
    TO_PRES.refresh = refresh;
    TO_PRES.blocksChanged = blocksChanged;
    TO_PRES.stop = stopAll;
})();
